"use client";
import Image from "next/image";
// import Logo from "@/app/images/Logo-Granuband_pay-off-1280x405-RGB.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTire } from "@awesome.me/kit-7e217e7a3f/icons/classic/solid";
import { useTireReading } from "@/app/context/TireReadingContext";

const TireReadingInfo = () => {
  const { currentReading } = useTireReading();

  return (
    <div className="flex flex-col items-center justify-center p-1 bg-white h-auto rounded-2xl shadow-md w-full relative border-4 border-[var(--granu-green)]">
      <FontAwesomeIcon icon={faTire} size="4x" color="black" className="mt-4" />

      <div className="w-full grid grid-cols-2 gap-4 text-center items-start">
        {/* Min Profile Depth */}
        <div className="flex flex-col w-full items-center justify-center p-4 gap-2 ">
          <h1>Bandenmaat</h1>
          <div className="w-full h-[1px] bg-gray-300 rounded-full"></div>
          <h2>
            {currentReading?.tire_width}/{currentReading?.tire_height} R
            {currentReading?.rim_diameter}
            {currentReading?.cargo ? "C" : ""}
          </h2>
        </div>

        <div className="flex flex-col w-full items-center justify-center p-4 gap-2 ">
          <h1>Profiel min.</h1>
          <div className="w-full h-[1px] bg-gray-300 rounded-full"></div>
          <h2>{currentReading?.minProfileDepth.toFixed(1) || "??"} mm </h2>
        </div>

        {/* Avg Profile Depth */}
        <div className="flex flex-col w-full items-center justify-center p-4 gap-2">
          <h1>Profiel gem.</h1>
          <div className="w-full h-[1px] bg-gray-300 rounded-full"></div>
          <h2>
            {currentReading
              ? currentReading.averageProfileDepth.toFixed(1)
              : "??"}{" "}
            mm
          </h2>
        </div>

        {/* Manufacturer */}
        <div className="flex flex-col w-full items-center justify-center p-4 gap-2">
          <h1>Merk:</h1>
          <div className="w-full h-[1px] bg-gray-300 rounded-full"></div>
          {/* <h2>{currentRea ,lo9ding?.manufacturerName ?? "--"}</h2> */}
          {currentReading?.manufacturerName && (
            <Image
              src={`https://granuband.blob.core.windows.net/manufacturers/${currentReading?.manufacturerName}.png`}
              alt="Manufacturer Logo"
              width={200}
              height={200}
              className="mt-2"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = "none"; // Hide the image if it fails to load
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TireReadingInfo;
